import React, { Children } from "react";
import { Button, Caption1, SkeletonLoader } from "@activecollab/components";
import PropTypes from "prop-types";

export const IntegrationsTable = ({ children, columns = [], addBtnText, isLoading = false, onAddClick }) => {
  const rows = Children.toArray(children);

  return (
    <div className="tw-w-full tw-border tw-border-solid tw-border-[var(--border-primary)] tw-rounded-md tw-overflow-auto">
      <div className="tw-w-full tw-h-10 tw-bg-[var(--color-theme-200)] tw-flex tw-gap-4 tw-items-center tw-p-3 tw-min-w-[500px]">
        {columns.length > 0 ? (
          <Caption1
            weight="bold"
            className="tw-flex-1 tw-max-w-[260px]"
          >
            {columns[0]}
          </Caption1>
        ) : null}
        {columns.length > 1 ? (
          <div className="tw-flex-1 tw-flex tw-items-center tw-gap-4">
            {columns.map((column, index) => {
              if (index === 0 || index === columns.length - 1) {
                return null;
              }
              return (
                <Caption1
                  key={column}
                  weight="bold"
                  className="tw-flex-1"
                >
                  {column}
                </Caption1>
              );
            })}
          </div>
        ) : null}
        {columns.length > 1 ? (
          <Caption1
            weight="bold"
            className="tw-w-[80px]"
          >
            {columns[columns.length - 1]}
          </Caption1>
        ) : null}
        <div className="tw-w-8"></div>
      </div>
      {isLoading ? (
        Array.from([1, 2, 3]).map((row) => (
          <div
            key={row}
            className="tw-w-full tw-h-12 tw-border-0 tw-border-t tw-border-solid tw-border-[var(--color-theme-300)]"
          >
            <div className="tw-h-full tw-w-full tw-flex tw-gap-4 tw-items-center tw-p-3">
              <SkeletonLoader className="tw-w-full" />
            </div>
          </div>
        ))
      ) : (
        <>
          {rows.length > 0
            ? rows.map((row, index) => (
                <div
                  key={index}
                  className="tw-w-full tw-h-12 tw-border-0 tw-border-t tw-border-solid tw-border-[var(--color-theme-300)] tw-min-w-[500px]"
                >
                  {row}
                </div>
              ))
            : null}
        </>
      )}
      <div className="tw-flex tw-items-center tw-px-1 tw-w-full tw-h-12 tw-border-0 tw-border-t tw-border-solid tw-border-[var(--color-theme-300)]">
        <Button
          variant="text colored"
          onClick={onAddClick}
        >
          <span className="tw-mr-1">+</span>
          {addBtnText}
        </Button>
      </div>
    </div>
  );
};

IntegrationsTable.propTypes = {
  columns: PropTypes.array,
  addBtnText: PropTypes.string,
  onAddClick: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.array,
};
